(() => {
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  const app = '[class^="alr-wh-"], [class*=" alr-wh-"], .alireviews-review-box, .alireviews-review-star-rating';
  const protectedContent = '.alr-wh-comp-text-content, [class*="author"], [class*="customer-name"], script, style, textarea';
  const pairs = [
    ['Klientų atsiliepimai', 'Customer reviews'],
    ['Parašykite atsiliepimą', 'Write a review'],
    ['Parašyti atsiliepimą', 'Write a review'],
    ['Ieškoti atsiliepimų', 'Search reviews'],
    ['Rūšiuoti pagal datą', 'Sort by date'],
    ['Rūšiuoti pagal įvertinimą', 'Sort by rating'],
    ['Rūšiuoti pagal turinį', 'Sort by content'],
    ['Rūšiuoti pagal žiniasklaidą', 'Sort by media'],
    ['Rūšiuoti pagal mediją ir datą', 'Sort by media and date'],
    ['Įkelti daugiau', 'Load more'],
    ['Patvirtintas pirkimas', 'Verified purchase'],
    ['Įvertinimas', 'Rating'],
    ['Pridėti žiniasklaidą', 'Add photos or videos'],
    ['Atsiliepimai', 'Reviews'],
    ['Pasidalykite mintimis apie gaminį', 'Share your thoughts about the product'],
    ['Pavadinimas', 'Name'],
    ['Įveskite savo vardą ir pavardę', 'Enter your full name'],
    ['Įveskite savo paštą', 'Enter your email address'],
    ['Pateikti apžvalgą', 'Submit review'],
    ['Atšaukti', 'Cancel'],
    ['Skaityti daugiau', 'Read more'],
    ['Rodyti mažiau', 'Show less'],
    ['Atsiliepimų nerasta', 'No reviews found'],
    ['Uždaryti', 'Close'],
    ['El. paštas', 'Email'],
    ['Atsiliepimų sąrašas', 'Reviews list'],
    ['Atsiliepimų rikiavimas', 'Sort review'],
    ['Rikiavimo parinktys', 'Sort options'],
    ['Atsiliepimų paieška ir filtrai', 'Filter and search reviews'],
    ['Atsiliepimų suvestinė ir nuotraukos', 'Review summary and media gallery'],
    ['Atsiliepimų įvertinimų suvestinė', 'Review rating summary'],
    ['Vidutinis įvertinimas ir atsiliepimų skaičius', 'Average rating and review count'],
    ['Atsiliepimų įvertinimų pasiskirstymas', 'Review rating breakdown'],
    ['Įvertinimų filtrai', 'Rating filters'],
    ['Atsiliepimų skaičius', 'Review counts'],
    ['Atsiliepimų statistika ir nuotraukos', 'Review statistics and media'],
    ['Užduoti klausimą', 'Ask a question'],
    ['Atsiliepimo tekstas', 'Review content']
  ];
  const dictionary = new Map(pairs.map(([lt, en]) => english ? [lt, en] : [en, lt]));
  if (!english) dictionary.set('Pavadinimas', 'Vardas ir pavardė');
  const translate = (value) => {
    const clean = value.trim();
    let next = dictionary.get(clean);
    if (!next && english) {
      next = clean
        .replace(/\b(\d+)\s+[Aa]tsiliepim(?:ai|ų|as)(?=$|[\s)])/gu, (_, n) => `${n} ${n === '1' ? 'review' : 'reviews'}`)
        .replace(/^Įvertinimas:\s*/, 'Rating: ');
      if (next.startsWith('Sort by Rūšiuoti')) next = dictionary.get(next.slice(8)) || next;
    }
    if (!next && !english) {
      next = clean
        .replace(/^Rate (\d+) stars?$/, 'Įvertinti $1 žvaigždutėmis')
        .replace(/^Total reviews: (\d+)$/, 'Atsiliepimų skaičius: $1')
        .replace(/^Average rating: ([\d.]+) out of 5 stars$/, 'Vidutinis įvertinimas: $1 iš 5')
        .replace(/^Sort by /, 'Rikiuoti: ')
        .replace(/^Filter by (\d) star reviews \((\d+) reviews, ([\d.]+)%\)$/, 'Filtruoti: $1/5; atsiliepimų: $2 ($3%)')
        .replace(/^(\d+) reviews for (\d) stars$/, 'Atsiliepimų su $2/5 įvertinimu: $1')
        .replace(/^(\d+) reviews$/, 'Atsiliepimų: $1')
        .replace(/^1 atsiliepimų$/i, '1 atsiliepimas');
    }
    return next && next !== clean ? value.replace(clean, next) : value;
  };
  const translateElement = (element) => {
    if (!element.closest(app) || element.closest(protectedContent)) return;
    if (element.tagName === 'H1') {
      if (element.getAttribute('role') !== 'heading') element.setAttribute('role', 'heading');
      if (element.getAttribute('aria-level') !== '2') element.setAttribute('aria-level', '2');
    }
    for (const attribute of ['aria-label', 'placeholder', 'title']) {
      const value = element.getAttribute(attribute);
      if (!value) continue;
      const next = translate(value);
      if (next !== value) element.setAttribute(attribute, next);
    }
    for (const node of element.childNodes) {
      if (node.nodeType !== Node.TEXT_NODE) continue;
      const next = translate(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  };
  const pending = new Map();
  let scheduled = false;
  const options = {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'placeholder', 'title']};
  const addPending = (element, deep) => {
    for (const [root, rootDeep] of pending) {
      if (root === element) { pending.set(root, rootDeep || deep); return; }
      if (rootDeep && root.contains(element)) return;
      if (deep && element.contains(root)) pending.delete(root);
    }
    pending.set(element, deep);
  };
  const queue = (node, deep = true) => {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element || !element.isConnected || element.closest(protectedContent)) return;
    if (element.closest(app)) addPending(element, deep);
    else if (deep) element.querySelectorAll(app).forEach(el => addPending(el, true));
    if (pending.size && !scheduled) {
      scheduled = true;
      if ('requestIdleCallback' in window) window.requestIdleCallback(flush, {timeout: 180});
      else window.setTimeout(flush, 16);
    }
  };
  const onMutations = (records) => {
    for (const record of records) {
      if (record.type === 'childList') record.addedNodes.forEach(node => queue(node, true));
      else queue(record.target, false);
    }
  };
  const observer = new MutationObserver(onMutations);
  const flush = () => {
    onMutations(observer.takeRecords());
    observer.disconnect();
    const batch = [...pending];
    pending.clear();
    scheduled = false;
    try {
      for (const [root, deep] of batch) {
        if (!root.isConnected) continue;
        translateElement(root);
        if (!deep) continue;
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
          acceptNode: node => node.matches(protectedContent) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
        });
        while (walker.nextNode()) translateElement(walker.currentNode);
      }
    } finally {
      observer.observe(document.body, options);
    }
  };
  observer.observe(document.body, options);
  queue(document.body);
})();
